import React from 'react';
interface TestimonialCardProps {
  quote: string;
  name: string;
  role: string;
}
const TestimonialCard: React.FC<TestimonialCardProps> = ({
  quote,
  name,
  role
}) => {
  return <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-152">
      <div className="mb-4 text-brown" data-id="element-153">
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-154">
          <path d="M11.0001 7C11.0001 7 10.0001 7.3 9.00005 8C8.00005 8.7 7.3 9.4 7.00005 10C6.70005 10.6 6.70005 11.3 7.00005 12C7.30005 12.7 8.00005 13 9.00005 13C9.50005 13 10.0001 12.8 10.5 12.5C11.0001 12.2 11.0001 12 11.0001 12C11.0001 12 10.7 12.2 10.0001 12.5C9.30005 12.8 8.50005 12.9 8.00005 12.5C7.50005 12.1 7.3 11.5 7.50005 11C7.70005 10.5 8.00005 10 9.00005 9.5C10.0001 9 11.0001 9 11.0001 9V7ZM18.0001 7C18.0001 7 17.0001 7.3 16.0001 8C15.0001 8.7 14.3 9.4 14.0001 10C13.7 10.6 13.7 11.3 14.0001 12C14.3 12.7 15.0001 13 16.0001 13C16.5001 13 17.0001 12.8 17.5001 12.5C18.0001 12.2 18.0001 12 18.0001 12C18.0001 12 17.7 12.2 17.0001 12.5C16.3 12.8 15.5001 12.9 15.0001 12.5C14.5001 12.1 14.3 11.5 14.5001 11C14.7 10.5 15.0001 10 16.0001 9.5C17.0001 9 18.0001 9 18.0001 9V7Z" fill="currentColor" data-id="element-155" />
        </svg>
      </div>
      <p className="text-gray-700 mb-6 italic" data-id="element-156">{quote}</p>
      <div data-id="element-157">
        <p className="font-bold text-brown" data-id="element-158">{name}</p>
        <p className="text-gray-600 text-sm" data-id="element-159">{role}</p>
      </div>
    </div>;
};
export default TestimonialCard;